import React, { Fragment } from 'react';
import { Divider, Flex, Text } from '@chakra-ui/react';
import { t } from '#i18n';
import { sortByAttribute } from '#utils/sorting';

import { ScrollableTable } from './ScrollableTable';
import { useRepositoriesQuery } from '#hooks/useRepositoriesQuery';

export const RepositoriesList = ({ selectedOrganization }) => {
  const { repositories } = useRepositoriesQuery({
    profileId: selectedOrganization?.id,
  });

  const activeFirstRepositories = repositories
    ? sortByAttribute(repositories, 'status', (a, b) => {
      if (a === 'ACTIVE' && b !== 'ACTIVE') return -1;
      if (a !== 'ACTIVE' && b === 'ACTIVE') return 1;
      return 0;
    })
    : [];

  return (
    <Flex
      flexDirection="column"
      maxHeight={{ base: '25rem', md: '30rem' }}
      minHeight="25rem"
      minWidth={{ base: '20rem', md: 'full' }}
      maxWidth="25rem"
    >
      <Flex
        width="full"
        paddingX={4}
        minHeight="3.625rem"
        maxHeight="3.625rem"
        alignItems="center"
        justifyContent="space-between"
      >
        <Flex flexDirection="column">
          {selectedOrganization && (
          <Text fontSize="xs" color="primary.100">
            {`${selectedOrganization.name} /`}
          </Text>
          )}
          <Text fontSize="md" fontWeight="medium">
            {t('settings.manageOrganizations.repositoriesHeader')}
          </Text>
        </Flex>
      </Flex>
      <Divider />
      <ScrollableTable>
        {activeFirstRepositories.map((repository) => (
          <RepositoryCell key={repository.id} repository={repository} />
        ))}
      </ScrollableTable>
    </Flex>
  );
};

const RepositoryCell = ({ repository }) => {
  const isActive = repository.status === 'ACTIVE';
  return (
    <>
      <Flex
        role="row"
        alignItems="center"
        minHeight="2.75rem"
        paddingX={4}
      >
        <Text color={isActive ? 'inherit' : 'primary.50'}>
          {repository.name}
        </Text>
      </Flex>
      <Divider />
    </>
  );
};
